import { actionTypes } from './actions';
import initialState from './initialState';

export default function loginReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state
        .set('loading', true)
        .set('token', '')
        .set('redirectUrl', action.payload.redirectUrl)
        .set('error', null);
    case actionTypes.SUCCESS:
      return state
        .set('loading', false)
        .set('token', action.payload.access_token)
        .set('refresh_token', action.payload.refresh_token)
        .set('error', null);
    case actionTypes.FAILURE:
      return state.set('loading', false).set('token', '').set('error', action.payload);
    case actionTypes.ES_AUTH_CHECK:
      return state
        .set('loading', true)
        .set('token', '')
        .set('redirectUrl', action.payload.redirectUrl)
        .set('ESAuthError', '')
        .set('ESAuthErrorId', '');
    case actionTypes.ES_AUTH_SUCCESS:
      return state
        .set('loading', false)
        .set('token', action.payload)
        .set('checkSuccess', true)
        .set('ESAuthError', '')
        .set('ESAuthErrorId', '');
    case actionTypes.ES_AUTH_FAILURE:
      return state
        .set('loading', false)
        .set('token', '')
        .set('checkSuccess', false)
        .set('ESAuthError', action.payload.error)
        .set('ESAuthErrorId', action.payload.errorId);
    case actionTypes.ES_USER_CREATED:
      return state
        .set('loading', false)
        .set('userCreated', true)
        .set('checkSuccess', true)
        .set('ESAuthError', '')
        .set('ESAuthErrorId', '');
    case actionTypes.ES_AUTH_WITH_EMAIL:
      return state.set('loading', true).set('redirectUrl', action.payload.redirectUrl);
    default:
      return state;
  }
}
